import React, { useEffect, useRef, useState } from "react";
import "./Achievements.css";
import { Card, Nav, Tab, Spinner } from "react-bootstrap";
import Explore_Btn from "../../common/explore-btn/Explore_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faSquareCheck,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AllProgramCategory,
  ProgramByID,
  AllProgramList,
} from "../../../features/admin/common/Slice";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Navigation, Autoplay } from "swiper/modules";
import {
  faCircleLeft,
  faCircleRight,
} from "@fortawesome/free-regular-svg-icons";

// ================= Program Card =================
const ProgramCard = ({ program }) => {
  const navigate = useNavigate();
  // const [activeCategory, setActiveCategory] = useState(null);
  // useEffect(() => {
  //   const activeTab = document.querySelector(
  //     `.custom_nav_pills .nav-link.active`,
  //   );

  //   if (activeTab) {
  //     // activeTab.scrollIntoView({
  //     //   behavior: "smooth",
  //     //   inline: "center",
  //     //   block: "nearest",
  //     // });
  //   }
  // }, [activeCategory]);

  return (
    <Card className="program_card">
      <Card.Body>
        <div className="badge_holder mb-3">
          <div className="badge_div">
            <p className="badge_text">Online Program</p>
          </div>
          <div className="badge_div">
            <p className="badge_text">
              <FontAwesomeIcon
                icon={faCircleCheck}
                style={{ color: "#006FCF" }}
              />{" "}
              NASSCOM Certified
            </p>
          </div>
        </div>

        <Card.Title className="program_title">{program?.name}</Card.Title>

        <Card.Subtitle className="program_subtitle mb-4">
          For {program?.eligibility}
        </Card.Subtitle>

        <div className="duration_holder">
          <div className="duration_div border_div">
            <p className="course_text">COURSE DURATION</p>
            <p className="duration">{program?.duration}</p>
          </div>
          <div className="duration_div">
            <p className="course_text">ELIGIBILITY</p>
            <p className="duration">{program?.eligibility}</p>
          </div>
        </div>

        <div className="program_highlights">
          <h6 className="highlight_text">Program highlights</h6>

          <div className="list_holder">
            {program?.key_highlights?.length > 0 ? (
              program.key_highlights.map((item) => (
                <p className="list_text" key={item.id}>
                  <FontAwesomeIcon
                    icon={faSquareCheck}
                    style={{ color: "#13ADF4", fontSize: "15px" }}
                  />{" "}
                  {item.highlight}
                </p>
              ))
            ) : (
              <p>No highlights available.</p>
            )}
          </div>
        </div>
      </Card.Body>
      <Card.Footer className="p-0">
        <div className="Explore_Btn_holder">
          <Explore_Btn
            onClick={() => navigate(`/explore-program/${program.id}`)}
          />
        </div>
      </Card.Footer>
    </Card>
  );
};

const Achievements = () => {
  const dispatch = useDispatch();

  const [activeCategory, setActiveCategory] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [allPrograms, setAllPrograms] = useState([]);

  const [loading, setLoading] = useState(false);

  const all_program_category = useSelector(
    (state) => state.common.all_program_category?.data || [],
  );

  // Fetch Categories
  useEffect(() => {
    dispatch(AllProgramCategory());
  }, [dispatch]);

  useEffect(() => {
    const fetchAll = async () => {
      const result = await dispatch(AllProgramList());
      setAllPrograms(result?.payload?.data || []);
    };

    fetchAll();
  }, [dispatch]);

  // Fetch Programs by Category
  useEffect(() => {
    const fetchPrograms = async () => {
      if (activeCategory && activeCategory !== "all") {
        setLoading(true);
        const result = await dispatch(ProgramByID(activeCategory));
        setPrograms(result?.payload?.data || []);
        setLoading(false);
      }
    };

    fetchPrograms();
  }, [activeCategory, dispatch]);

  // Set All Default
  useEffect(() => {
    if (all_program_category.length > 0 && activeCategory === null) {
      setActiveCategory("all");
    }
  }, [all_program_category, activeCategory]);

  const navRef = useRef(null);
  const scrollLeft = () => {
    if (navRef.current) {
      navRef.current.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (navRef.current) {
      navRef.current.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="Achievements">
      <div className="Achievements_header_holder">
        <h6 className="Achievements_title">Courses That Turn</h6>
        <h5 className="Achievements_subtitle">Ambition into Achievement</h5>
      </div>

      <div className="container">
        <div className="program_container">
          <Tab.Container activeKey={activeCategory}>
            <div className="tab_holder">
              <div className="arrow_holder" onClick={scrollLeft}>
                <FontAwesomeIcon icon={faCircleLeft} className="arrow_icon" />
              </div>
              {/* ✅ Tabs ALWAYS visible */}
              <Nav
                ref={navRef}
                variant="pills"
                className="custom_nav_pills p-1"
                onSelect={(k) => setActiveCategory(k)}
              >
                <Nav.Item>
                  <Nav.Link eventKey="all">All</Nav.Link>
                </Nav.Item>

                {all_program_category.map((category) => (
                  <Nav.Item key={category.id}>
                    <Nav.Link
                      eventKey={category.id}
                      onClick={(e) => {
                        e.currentTarget.scrollIntoView({
                          behavior: "smooth",
                          inline: "center",
                          block: "nearest",
                        });
                      }}
                    >
                      {category.name}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>

              <div className="arrow_holder" onClick={scrollRight}>
                <FontAwesomeIcon icon={faCircleRight} className="arrow_icon" />
              </div>
            </div>
            {loading ? (
              <div className="text-center my-5">
                <Spinner animation="border" variant="primary" />
                <p>Loading programs...</p>
              </div>
            ) : (
              <Tab.Content>
                <Tab.Pane eventKey={activeCategory}>
                  <Swiper
                    modules={[Navigation, Autoplay]}
                    spaceBetween={20}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: false,
                    }}
                    loop={
                      (activeCategory === "all" ? allPrograms : programs)
                        .length > 3
                    }
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      576: { slidesPerView: 1.2 },
                      768: { slidesPerView: 2 },
                      992: { slidesPerView: 3 },
                    }}
                  >
                    {(activeCategory === "all" ? allPrograms : programs).map(
                      (program) => (
                        <SwiperSlide key={program.id}>
                          <ProgramCard program={program} />
                        </SwiperSlide>
                      ),
                    )}
                  </Swiper>
                </Tab.Pane>
              </Tab.Content>
            )}
          </Tab.Container>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
